import { Location } from '@angular/common'
import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, Renderer2, ViewContainerRef, ViewEncapsulation} from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { from, Subject, Subscription} from 'rxjs'
import { take, takeUntil } from 'rxjs/operators'
import { NomadeService } from '../../../../../nomade/services/nomade.service'
import { DialogService } from '../../../../../services'
import { StateService } from '../../../../../services/App/state.service'
import { FormDialogComponent } from '../dialogs/form-dialog/form-dialog.component'
import { ConfirmComponent } from '../../../layout/dialogs/confirm-dialog/confirm.component'
import { NomadeDossierComponent } from '../nomade-dossier/nomade-dossier.component'
import { MatDialog } from '@angular/material/dialog'
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs'
@Component({
    selector: "atyl-nomade-consultation",
    templateUrl: "./nomade-consulltation.component.html",
    styleUrls: ['./nomade-consulltation.component.scss'],
    encapsulation : ViewEncapsulation.None
})
export class NomadeConsultationComponent {

    currentConsultation: any
    unsubscribe = new Subject<void>();
    formulairesActionsList:any[] = [];
    dossiersList:any[] = [];
    showDossier:boolean = false;
    loadedConsult:boolean = true;

    
    constructor(
        private activatedRoute: ActivatedRoute,
        private nomadeService: NomadeService,
        private el: ElementRef,
        private render: Renderer2,
        private changeDetectorRef: ChangeDetectorRef,
        private dialogService: DialogService,
        private location: Location,
        private stateService: StateService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        //this.__load__current__consultation__();
        this.__load__dossiersList__();
        this.loadCSS('./assets/css/style.bundle.css');
        this.loadFormTypesList();
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    private __load__current__consultation__() {
        this.nomadeService.getConsultationById(parseInt(this.activatedRoute.snapshot.params.id)).subscribe(response => {
            this.currentConsultation = this.nomadeService.parse(response)
            console.log(this.currentConsultation, "getConsultationById,current")
            this.currentConsultation.visites.map(visite=>{
                visite.tiers.dossier = this.dossiersList.find(dossier=>dossier.id == visite.tiers.dossierID);
            })
            from(this.nomadeService.requestes())
            .pipe(
              takeUntil(this.unsubscribe)
            )
            .subscribe(requestes => {
                this.setConsultationAddedObjects(requestes);
                this.loadedConsult = true;
            });
            
            this.changeDetectorRef.detectChanges();
        })
    }

    private __load__dossiersList__(){
		this.nomadeService.dossiers().subscribe(response => {
			response.forEach(element => {
				this.dossiersList.push(this.nomadeService.parse(element))
			})
            this.__load__current__consultation__();
        })
    }

    private loadCSS(styleUrl: string) {
        return new Promise((resolve, reject) => {
            const styleElement = document.createElement('link')
            styleElement.href = styleUrl
            styleElement.type = 'text/css'
            styleElement.rel = 'stylesheet'
            styleElement.onload = resolve
            this.render.appendChild(this.el.nativeElement, styleElement)
        })
    }
    openForm(form: any,visite:any) {
        console.log("openForm", form,visite)
        const dossier = visite.tiers.dossier;
        this.dialogService.open(FormDialogComponent, {
            data: {
                form: form,
                title: form.form.libelle,
                dossier: dossier,
                visite: visite
            },
            maximizable: true,
            minimizable: true,
            draggable: true,
            resizable: true,
            width: "80vw",
            height: "90vh"
        })
    }

    back(): void {
        this.location.back()
    }

    setConsultationAddedObjects(requestes){
        this.currentConsultation.visites.map(visite => {
            visite.addedObjects = {
                forms:[]
            }
        });
        if(requestes.length>0){
            requestes.forEach(req => {
                this.addObjectsRequestToList(req);
            });
        }
        this.changeDetectorRef.detectChanges();
    }

    addObjectsRequestToList(request: any){
        if(request.method == "webservice.formulaire:set" 
        && request.params.idDemande == 0 
        && request.params.options.visiteNomade != undefined
        && request.params.options.parentNomadeId != undefined)
        {
            var currentVisiteIdx = this.currentConsultation.visites.findIndex(visite=>visite.ID == request.params.options.visiteNomade)
            if(currentVisiteIdx != -1){
                if(this.currentConsultation.visites[currentVisiteIdx].addedObjects == undefined){
                    this.currentConsultation.visites[currentVisiteIdx].addedObjects = {
                        forms:[]
                    };
                }
                var currentFormGroupIndex = this.currentConsultation.visites[currentVisiteIdx].addedObjects.forms.findIndex(form => form.nomadeId == request.params.options.parentNomadeId);
                var currentFormGroup = null;
                if(currentFormGroupIndex == -1){
                    currentFormGroup = ({
                        nomadeId: request.params.options.parentNomadeId,
                        formId: request.params.options.parentForm,
                        formLibelle: request.params.options.parentLibelle,
                        visiteID: request.params.options.visiteNomade,
                        dateModif : request.params.options.demande_date_debut,
                        dossier: request.params.options.dossier,
                        underFormsReq: []
                    })
                    currentFormGroup.underFormsReq.push(request);
                    this.currentConsultation.visites[currentVisiteIdx].addedObjects.forms.push(currentFormGroup);
                }
                else{
                    currentFormGroup = this.currentConsultation.visites[currentVisiteIdx].addedObjects.forms[currentFormGroupIndex];
                    var currentQueryIdx = currentFormGroup.underFormsReq.findIndex(req=>req.id == request.id)
                    if(currentQueryIdx != -1){
                        currentFormGroup.underFormsReq[currentQueryIdx] = request;
                    }
                    else{
                        currentFormGroup.underFormsReq.push(request);
                    }
                    if(!currentFormGroup.dateModif){
                        currentFormGroup.dateModif = request.params.options.demande_date_debut;
                    }
                    this.currentConsultation.visites[currentVisiteIdx].addedObjects.forms[currentFormGroupIndex] = currentFormGroup;
                }
                this.sortFormsByDate(currentVisiteIdx);
                this.changeDetectorRef.detectChanges();
            }
        }
    }

    sortFormsByDate(visiteIdx): void {
        this.currentConsultation.visites[visiteIdx].addedObjects.forms = this.currentConsultation.visites[visiteIdx].addedObjects.forms.sort((a: any, b: any) => {
          const dateA = new Date(a.dateModif);
          const dateB = new Date(b.dateModif);
          return dateB.getTime() - dateA.getTime();
        });
    }

    openNomadeForm(nomadeForm: any){
        var action = this.formulairesActionsList.find(action=>action.form.ID == nomadeForm.formId);
        var visite = this.currentConsultation.visites.find(visite=>visite.ID == nomadeForm.visiteID);
        if(action && visite){
            action.form = this.setChampsFromNomadeForm(action.form,nomadeForm);
            console.log("OPEN_NOMADE",action,nomadeForm)
            this.dialogService.open(FormDialogComponent, {
                data : {
                    form: action,
                    title: nomadeForm.formLibelle,
                    dossier: nomadeForm.dossier,
                    nomadeForm: nomadeForm,
                    visite: visite
                },
                maximizable: true,
                minimizable: true,
                draggable: true,
                resizable: true,
                width: "80vw",
                height: "90vh"
            })

        }
    }

    setChampsFromNomadeForm(form,nomadeForm){
        var currentReq = nomadeForm.underFormsReq.find(req=>req.params.type == form.ID)
        if(currentReq){
            form.fields = currentReq.params.options.fields
        }
        if(form.under_form){
            form.under_form.forEach(f => {
                f = this.setChampsFromNomadeForm(f,nomadeForm);
            });
        }
        return form;
    } 

    loadFormTypesList(){
        this.stateService.pages.pipe(takeUntil(this.unsubscribe)).subscribe((pages) => {
            this.formulairesActionsList = [];
            if(pages){
                pages.forEach(page => {
                    page.actions.forEach(action => {
                        if(action.form != undefined && action.form.form != undefined){
                            this.formulairesActionsList.push(action.form)
                        }
                    });
                });
            }
        })
    }

    closeForm(event: Event, nomadeForm: any) {
        event.stopPropagation();
        const dialogRef = this.dialogService.open(ConfirmComponent, {
            width: '250px',
            data : {
                libelle : 'Etes-vous sur de vouloir supprimer ce formulaire ?'
            }
        });
    
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                nomadeForm.underFormsReq.forEach(request => {
                    console.log("requete supprimée", request);
                    this.nomadeService.deleteRequest(request.id);
                });
            }
        });
    }

    changeVisiteSelected(tabGroup: MatTabGroup){
        setTimeout(() => {
            tabGroup.realignInkBar();
        });
    }

    onTabChange(event: any,atylNomadeDossier: NomadeDossierComponent) {
        if(event==1){
            setTimeout(() => {
                atylNomadeDossier.refreshInkBar();    
            });
        }
    }

}